import {createMachine} from 'xstate'
import {assign} from '@xstate/immer'

interface ProviderInfoCardGalleryContext {
  count: number
  index: number
  interval: number
}

type ProviderInfoCardGalleryEvent = {type: 'TICK'}

type ProviderInfoCardGalleryState = {
  context: ProviderInfoCardGalleryContext
  value: 'idle'
}

export const providerInfoCardGalleryMachine = createMachine<
  ProviderInfoCardGalleryContext,
  ProviderInfoCardGalleryEvent,
  ProviderInfoCardGalleryState
>(
  {
    id: 'providerInfoCardGallery',
    initial: 'running',
    schema: {
      context: {} as ProviderInfoCardGalleryContext,
      events: {} as ProviderInfoCardGalleryEvent,
      services: {} as {
        tick: {
          data: void
        }
      },
    },
    context: {
      count: 0,
      index: 0,
      interval: 5,
    },
    states: {
      running: {
        on: {
          TICK: {
            actions: 'updateIndex',
          },
        },
        invoke: {
          id: 'tick',
          src: (ctx) => (cb) => {
            const interval = setInterval(() => {
              cb('TICK')
            }, 1000 * ctx.interval)

            return () => clearInterval(interval)
          },
        },
      },
    },
  },
  {
    actions: {
      updateIndex: assign((ctx) => {
        ctx.index = (ctx.index + 1) % ctx.count
      }),
    },
  }
)
